export function convertTo12HourTime(time24: string) {
	if (!time24) {
		return time24;
	}
	const [hours, minutes] = time24.split(':');
	let period = 'AM';
	let hour = parseInt(hours, 10);

	if (hour >= 12) {
		period = 'PM';
		if (hour > 12) {
			hour -= 12;
		}
	}

	return `${hour.toString().padStart(2, '0')}:${minutes} ${period}`;
}

export function dateFormatter(date: string) {
	if (!date) {
		return '';
	}

	const formattedDate = `${new Date(date).getDate().toString().padStart(2, '0')}/${(new Date(date).getMonth() + 1).toString().padStart(2, '0')}/${new Date(date).getFullYear().toString()}`;

	return formattedDate;
}

export function getLastChatDate(date: string) {
	const yesterday = new Date(new Date());
	yesterday.setDate(new Date().getDate() - 1);

	if (date?.split(' ')[0] === new Date().toISOString().split('T')[0]) {
		return 'Today';
	} else if (yesterday.toISOString().slice(0, 10) === date?.split(' ')[0]) {
		return 'Yesterday';
	} else {
		return dateFormatter(date?.split(' ')[0]);
	}
}
